import { FC } from 'react'
import styled from 'styled-components'
import { Container, Row, Col } from '@mch-group/uikit-components'
import { GooglePlay, AppStore } from '@components'
import { uploadTransformationUrl } from '@dmi-mch/utils'
import { cloudinary } from '@constants'
import { Text, CustomLinkTag } from '@components'
import IAppStoreBanner from './IAppStoreBanner'
import tokens from '@mch-group/design-tokens/build/js/design_tokens-module'

const StyledDefaultView = styled.section`
  background: var(--bs-mch-gray-200);

  @media (min-width: ${global.uikitVars.breakpointMd}) {
    .qr-code-sec {
      border: 1px solid ${tokens.color.light.base.neutrals[0].value};
      padding: 18px;
    }
  }

  @media (max-width: ${global.uikitVars.breakpointSmMax}) {
    .qr-code-seperator {
      border-top: 1px solid ${tokens.color.light.base.neutrals[0].value};

      .qr-code-sec {
        margin-top: 32px;
      }
    }
  }
`

const StyledImg = styled.img`
  @media (max-width: ${global.uikitVars.breakpointMdMax}) {
    width: 100vw;
  }
`

const DefaultView: FC<IAppStoreBanner> = ({
  dabm_grp1_title,
  dabm_grp1_description,
  dabm_grp1_image,
  dabm_grp1_qr_code_image,
  dabm_grp1_google_play_url,
  dabm_grp1_app_store_url,
  dabm_grp1_get_the_app_label
}) => (
  <StyledDefaultView>
    <Container className='px-5 px-lg-8 px-md-7'>
      <Row className='d-flex align-items-center'>
        <Col className='col-12 col-lg-4 col-xl-4 col-xxl-6 mb-6 mb-md-10 mb-lg-0 mt-lg-14 order-2 order-lg-1'>
          <Row>
            <Col className='col-12 mt-8 mt-lg-0 mt-md-10'>
              <h3>{dabm_grp1_title}</h3>
              <Text isHtml className='text-medium mt-3 mt-lg-5'>
                {dabm_grp1_description}
              </Text>
            </Col>
          </Row>
          <Row className='mt-5 mt-xl-10'>
            <Col className='mt-0 mt-lg-5 mt-md-8'>
              <div className='d-flex qr-code-seperator'>
                <div className='d-flex qr-code-sec'>
                  <div>
                    <h1 className='header-uppercase-2 mb-2'>{dabm_grp1_get_the_app_label}</h1>
                    <div className='mb-5 d-inline-block d-md-block me-4 me-md-0'>
                      <CustomLinkTag url={dabm_grp1_google_play_url}>
                        <GooglePlay />
                      </CustomLinkTag>
                    </div>
                    <CustomLinkTag url={dabm_grp1_app_store_url}>
                      <AppStore />
                    </CustomLinkTag>
                  </div>
                  <div className='ms-9 d-none d-md-block'>
                    <img
                      src={uploadTransformationUrl(
                      dabm_grp1_qr_code_image,
                      'w_112',
                      { 'transformUrl': cloudinary.throughCloudfront }
                    )}
                      alt={dabm_grp1_qr_code_image}
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
        <Col className='col-12 col-lg-8 col-xl-8 col-xxl-6 order-1 order-lg-2 mt-md-0'>
          <StyledImg
            src={uploadTransformationUrl(
              dabm_grp1_image,
              'w_940,ar_3:2',
              { 'transformUrl': cloudinary.throughCloudfront }
            )}
            alt={dabm_grp1_image}
          />
        </Col>
      </Row>
    </Container>
  </StyledDefaultView>
)

export default DefaultView
